import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { selectArticlegroupArticlesMap } from "./selectArticlegroupArticlesMap.ts";

// Find all campaigns for an article with O(1) performance
export const selectArticleCampaignsMap = createSelector(
  [
    (state: RootState) => state.menuData.campaign_products,
    (state: RootState) => state.menuData.campaign_product_groups,
    selectArticlegroupArticlesMap,
  ],
  (campaign_products, campaign_product_groups, articlegroupArticles) => {
    const articleIdCampaignIdsMap: Record<string, string[]> = {};

    campaign_products.forEach((pivot) => {
      if (!articleIdCampaignIdsMap[pivot.product_id]) {
        articleIdCampaignIdsMap[pivot.product_id] = [];
      }
      articleIdCampaignIdsMap[pivot.product_id].push(pivot.campaign_id);
    });

    campaign_product_groups.forEach((pivot) => {
      for (const articleId of articlegroupArticles[pivot.product_group_id] ?? []) {
        if (!articleIdCampaignIdsMap[articleId]) {
          articleIdCampaignIdsMap[articleId] = [];
        }
        articleIdCampaignIdsMap[articleId].push(pivot.campaign_id);
      }
    });

    return articleIdCampaignIdsMap;
  }
);
